import React, { useState } from "react";
import "./exceptions.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";

function Exceptions() {
  const [masterGuide, setMasterGuide] = useState("");
  const [error, setError] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [houses, setHouses] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState("");

  const initialCheckStates = {
    manejoCarga: false,
    refrigeracion: false,
    congelacion: false,
    screening: false,
    dgFee: false,
    manejoValor: false,
    flejeEmpaque: false,
    cancelacionFactura: false,
    animalesVivos: false,
    dgExentas: false,
    hieloSeco: false,
  };

  const conceptoDisplayNames = {
    manejoCarga: "Manejo carga",
    refrigeracion: "Refrigeración",
    congelacion: "Congelación",
    screening: "Screening",
    dgFee: "DG Fee",
    manejoValor: "Manejo valor",
    flejeEmpaque: "Fleje/empaque",
    cancelacionFactura: "Cancelación factura",
    animalesVivos: "Animales vivos",
    dgExentas: "DG exentas",
    hieloSeco: "Hielo seco",
  };

  const exceptionChargeMap = {
    manejoCarga: 1,
    refrigeracion: 2,
    congelacion: 3,
    screening: 4,
    dgFee: 5,
    manejoValor: 6,
    flejeEmpaque: 7,
    cancelacionFactura: 8,
    animalesVivos: 9,
    dgExentas: 10,
    hieloSeco: 11,
  };

  const exceptionTypeMap = {
    opt1: 1,
    opt2: 2,
    opt3: 3,
    opt4: 4,
  };

  const currencyMap = {
    MXN: 1,
    USD: 2,
  };

  const initialRowStates = Object.keys(initialCheckStates).reduce(
    (acc, key) => {
      acc[key] = { tipoExcepcion: "", moneda: "" };
      return acc;
    },
    {}
  );

  const [checkStates, setCheckStates] = useState(initialCheckStates);
  const [rowStates, setRowStates] = useState(initialRowStates);

  const tipoExcepcionOptions = [
    { value: "opt1", label: "Descuento %" },
    { value: "opt2", label: "Tarifa fija" },
    { value: "opt3", label: "Descuento sobre tarifa" },
    { value: "opt4", label: "Cobro por pieza" },
  ];

  const monedaOptions = [
    { value: "MXN", label: "MXN" },
    { value: "USD", label: "USD" },
  ];

  const renderSelect = (enabled, value, onChange, options = []) => (
    <select
      className="form-select"
      disabled={!enabled}
      value={value}
      onChange={onChange}
    >
      <option value="" disabled hidden={!enabled}>
        {enabled ? "Selecciona..." : ""}
      </option>
      {options.map((opt) => (
        <option key={opt.value || opt} value={opt.value || opt}>
          {opt.label || opt}
        </option>
      ))}
    </select>
  );

  const fetchHousesSimulado = (guide) => {
    const trimmedGuide = guide.trim();

    if (trimmedGuide === "123-44448888") {
      setHouses(["HBS1", "HBS2", "HBS3", "HBS4", "HBS5"]);
      setError("");
    } else if (trimmedGuide === "123-44447777") {
      setHouses(["N/A"]);
      setError("");
    } else if (trimmedGuide === "") {
      setHouses([]);
      setError("");
    } else {
      setHouses([]);
      setError("La master no existe, favor de verificar");
    }

    setSelectedHouse("");
    setShowTable(false);
    setShowSaveButton(false);
  };

  const handleSearch = () => {
    if (!masterGuide.trim()) {
      setError("Por favor ingresa una guía master.");
      setShowTable(false);
      setShowSaveButton(false);
      return;
    }

    const hasRealHouses = houses.length > 0 && houses[0] !== "N/A";

    if (hasRealHouses && !selectedHouse) {
      setError("Por favor selecciona una house.");
      setShowTable(false);
      setShowSaveButton(false);
      return;
    }

    setError("");
    setShowTable(true);
    setShowSaveButton(true);
  };

  const handleCheckChange = (key) => {
    setCheckStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleRowSelectChange = (key, field, value) => {
    setRowStates((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const handleGuardar = () => {
    const datosGuardados = [];

    Object.keys(checkStates).forEach((key) => {
      if (checkStates[key]) {
        const cantidad =
          document.getElementById(`cantidad-${key}`)?.value || "";

        datosGuardados.push({
          id: null,
          exp_master_id: masterGuide || null,
          exp_house_id:
            selectedHouse && selectedHouse !== "N/A" ? selectedHouse : null,
          exception_charge_id: exceptionChargeMap[key] || null,
          exception_type_id:
            exceptionTypeMap[rowStates[key].tipoExcepcion] || null,
          value: cantidad || null,
          currency_id: currencyMap[rowStates[key].moneda] || null,
          is_third_party: null,
          created_at: "",
          updated_at: "",
          deleted_at: null,
        });
      }
    });

    console.log("Payload para el backend:", datosGuardados);

    Swal.fire({
      title: "Éxito",
      text: "Datos guardados con éxito",
      icon: "success",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>Horus | Excepciones</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-8">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="inputMaster" className="amc-label">
                  Guía Master
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputMaster"
                  value={masterGuide}
                  onChange={(e) => {
                    let raw = e.target.value.replace(/[^0-9]/g, "");
                    if (raw.length > 11) raw = raw.slice(0, 11);
                    let formatted = raw;
                    if (raw.length > 3) {
                      formatted = raw.slice(0, 3) + "-" + raw.slice(3);
                    }
                    setMasterGuide(formatted);
                    fetchHousesSimulado(formatted);
                  }}
                />
                {error && <div className="text-danger mt-2">{error}</div>}
              </div>

              <div className="col-md-6">
                <label htmlFor="selectHouse" className="amc-label">
                  Guía House
                </label>
                <select
                  id="selectHouse"
                  className="form-select"
                  value={selectedHouse}
                  onChange={(e) => setSelectedHouse(e.target.value)}
                >
                  {houses.length === 0 ? (
                    <option value="" disabled></option>
                  ) : houses[0] === "N/A" ? (
                    <option value="N/A">N/A</option>
                  ) : (
                    <>
                      <option value="" disabled>
                        Selecciona house...
                      </option>
                      {houses.map((house, idx) => (
                        <option key={idx} value={house}>
                          {house}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>

            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleSearch}>
                Buscar
              </button>
            </div>
          </div>

          {showTable && (
            <div className="col-md-12 mt-4">
              <table className="table fondo-headBilling">
                <thead>
                  <tr className="text-center">
                    <th>Concepto</th>
                    <th>Excepción</th>
                    <th>Tipo excepción</th>
                    <th>Cantidad</th>
                    <th>Moneda</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(checkStates).map((key) => (
                    <tr key={key} className="align-middle">
                      <td>{conceptoDisplayNames[key] || key}</td>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={checkStates[key]}
                          onChange={() => handleCheckChange(key)}
                        />
                      </td>
                      <td>
                        {renderSelect(
                          checkStates[key],
                          rowStates[key].tipoExcepcion,
                          (e) =>
                            handleRowSelectChange(
                              key,
                              "tipoExcepcion",
                              e.target.value
                            ),
                          tipoExcepcionOptions
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          disabled={!checkStates[key]}
                          id={`cantidad-${key}`}
                          onInput={(e) => {
                            const cleaned = e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1");
                            e.target.value = cleaned;
                          }}
                        />
                      </td>
                      <td>
                        {key === "congelacion" ? (
                          <div className="row">
                            <div className="col-md-6">
                              {renderSelect(
                                checkStates[key],
                                rowStates[key].moneda,
                                (e) =>
                                  handleRowSelectChange(
                                    key,
                                    "moneda",
                                    e.target.value
                                  ),
                                monedaOptions
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-2">
                                <label className="form-check-label">
                                  ¿Precio terceros?
                                </label>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  disabled={!checkStates[key]}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          renderSelect(
                            checkStates[key],
                            rowStates[key].moneda,
                            (e) =>
                              handleRowSelectChange(
                                key,
                                "moneda",
                                e.target.value
                              ),
                            monedaOptions
                          )
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {showSaveButton && (
            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleGuardar}>
                Guardar
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Exceptions;
